import { httpsUrlRegex } from '../utils/validation';

export type ChatMessageTextPart = {
  text: string;
  isLink: boolean;
};

export const splitChatMessageText = (text: string): ChatMessageTextPart[] => {
  const parts: ChatMessageTextPart[] = [];
  let currentIndex = 0;

  for (const match of Array.from(text.matchAll(httpsUrlRegex))) {
    const matchIndex = match.index ?? 0;
    if (matchIndex > currentIndex) {
      parts.push({ text: text.slice(currentIndex, matchIndex), isLink: false });
    }
    parts.push({ text: match[0], isLink: true });
    currentIndex = matchIndex + match[0].length;
  }

  if (currentIndex < text.length) {
    parts.push({ text: text.slice(currentIndex), isLink: false });
  }

  return parts;
};
